import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	linkActiveClass: 'active',
	routes: [{
		path: '/',
		name: 'FrontPage',
		meta: {
			title: '首页'
		},
		component: resolve => require(['@/components/FrontPage'], resolve)
	},{
		path: '/silicon-Material',
		name: 'SiliconMaterialPage',
		meta: {
			title: 'Silicon Material',
			bread:[{"url":"/","title":"Index"},{"url":"","title":"Silicon Material"}],
		},
		component: resolve => require(['@/components/SiliconMaterial/ListPage'], resolve),
		children: [{
			path: 'fz-production-technology',
			name: 'FZProductionPage',
			meta:{
				title:'FZ-production technology',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'FZ-production technology',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Silicon Material"},{"url":"javascript:;","title":"FZ-production technology"}],
			},
			component: resolve => require(['@/components/SiliconMaterial/FZProductionPage'], resolve),
		},{
			path: 'cz-production-technology',
			name: 'CZProductionPage',
			meta:{
				title:'CZ-production technology',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'CZ-production technology',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Silicon Material"},{"url":"javascript:;","title":"CZ-production technology"}],
			},
			component: resolve => require(['@/components/SiliconMaterial/CZProductionPage'], resolve),
		},{
			path: 'process-options',
			name: 'ProcessOptionsPage',
			meta:{
				title:'Process Options',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Process Options',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Silicon Material"},{"url":"","title":"Process Options"}],
			},
			component: resolve => require(['@/components/SiliconMaterial/ProcessOptions'], resolve),
		}]
	},{
		path: '/semiconductor-ic-discrete-device',
		name: 'ProductPage',
		meta: {
			title: 'Semiconductor IC & Discrete Device',
			bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor IC & Discrete Device"}],
		},
		component: resolve => require(['@/components/SemiconductorICDiscreteDevice/ListPage'], resolve),
		children: [{
			path: '8-inch-12-inch-wafer-production-line',
			name: 'oneProduct',
			meta:{
				title:'8 inch & 12 inch wafer production line',
				bgImg:'image/product-page-banner.jpg',
				pageH1:'8-inch-12-inch-wafer-production-line',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Semiconductor IC & Discrete Device"},{"url":"javascript:;","title":"8 inch & 12 inch wafer production line"}],
			},
			component: resolve => require(['@/components/SemiconductorICDiscreteDevice/8InchI2'], resolve),
		},{
			path: '6-inch-silicon-wafer-line',
			name: 'oneProduct',
			meta:{
				title:'6 inch silicon wafer line',
				bgImg:'image/product-page-banner.jpg',
				pageH1:'6-inch-silicon-wafer-line',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Semiconductor IC & Discrete Device"},{"url":"javascript:;","title":"6 inch silicon wafer line"}],
			},
			component: resolve => require(['@/components/SemiconductorICDiscreteDevice/6Inch'], resolve),
		},{
			path: 'production-list',
			name: 'ProductionListPage',
			meta:{
				title:'Production List',
				bgImg:'image/product-page-banner.jpg',
				pageH1:'Production List',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor IC & Discrete Device"},{"url":"","title":"Production List"}],
			},
			component: resolve => require(['@/components/SemiconductorICDiscreteDevice/ProductionList'], resolve),
		}]
	},{
		path: '/semiconductor-assembly-and-testing',
		name: 'SAATPage',
		meta: {
			title: 'Semiconductor assembly and testing',
			bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"}],
		},
		component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/ListPage.vue'], resolve),
		children: [{
			path: 'manufacturing-layout',
			name: 'ManufacturingLayout',
			meta:{
				title:'Manufacturing Layout',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Manufacturing Layout',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Manufacturing Layout"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/ManufacturingLayout'], resolve),
		},{
			path: 'osat-turnkey-service',
			name: 'OSATTurnkeyService',
			meta:{
				title:'OSAT Turnkey Service',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'OSAT Turnkey Service',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"OSAT Turnkey Service"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/OSATTurnkeyService'], resolve),
		},{
			path: 'products-trategy',
			name: 'ProductsStrategy',
			meta:{
				title:'Products Strategy',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Products Strategy',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Products Strategy"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/ProductsStrategy'], resolve),
		},{
			path: 'test-service',
			name: 'TestService',
			meta:{
				title:'Test Service',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Test Service',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Test Service"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/TestService'], resolve),
		},{
			path: 'co-design-simulation',
			name: 'CoDesignSimulation',
			meta:{
				title:'Co-Design Simulation',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Co-Design Simulation',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Co-Design Simulation"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/CoDesignSimulation'], resolve),
		},{
			path: 'fa-ra-ability',
			name: 'FARAAbility',
			meta:{
				title:'FA& RA Ability',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'FA& RA Ability',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"FA& RA Ability"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/FARAAbility'], resolve),
		},{
			path: 'quality-certification',
			name: 'QualityCertification',
			meta:{
				title:'Quality Certification',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Quality Certification',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Quality Certification"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/QualityCertification'], resolve),
		},{
			path: 'expeni-mental-and-analysis-ability',
			name: 'ExpeniMentalAndAnalysisAbility',
			meta:{
				title:'Expenimental and Analysis ability',
				bgImg:'image/SAAT/Semiconductor-assembly-and-testing-banner.png',
				pageH1:'Expenimental and Analysis ability',
				bread:[{"url":"/","title":"Index"},{"url":"","title":"Semiconductor assembly and testing"},{"url":"","title":"Expenimental and Analysis ability"}],
			},
			component: resolve => require(['@/components/SemiconductorAssemblyAndTesting/ExpeniMentalAndAnalysisAbility'], resolve),
		}]
	},{
		path: '/precision-stamping-part',//
		name: 'PrecisionStampingPart',
		meta: {
			title: 'Precision Stamping Part',
			bread:[{"url":"/","title":"Index"},{"url":"","title":"Precision Stamping Part"}],
		},
		component: resolve => require(['@/components/SiliconMaterial/ListPage'], resolve),
		children: [{
			path: 'precision-stamping-and-injection',
			name: 'PrecisionStampingAndInjection',
			meta:{
				title:'Precision stamping and injection',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Precision stamping and injection',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Precision stamping and injection"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/PrecisionStampingAndInjection'], resolve),
		},{
			path: 'structure-parts-stamping',
			name: 'StructurePartsStamping',
			meta:{
				title:'Structure parts stamping',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Structure parts stamping',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Structure parts stamping"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/StructurePartsStamping'], resolve),
		},{
			path: 'optical-electric-products',
			name: 'OpticalElectricProducts',
			meta:{
				title:'Optical electric products',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Optical electric products',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Optical electric products"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/OpticalElectricProducts'], resolve),
		},{
			path: 'connectors-and-plugs',
			name: 'ConnectorsAndPlugs',
			meta:{
				title:'Connectors and plugs',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Connectors and plugs',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Connectors and plugs"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/ConnectorsAndPlugs'], resolve),
		},{
			path: 'tool-development-and-fabrication',
			name: 'ToolDevelopmentAndFabrication',
			meta:{
				title:'Tool development and fabrication',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Tool development and fabrication',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Tool development and fabrication"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/ToolDevelopmentAndFabrication'], resolve),
		},{
			path: 'fpc-smt',
			name: 'FPCSMT',
			meta:{
				title:'FPC SMT',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'FPC SMT',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"FPC SMT"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/FPCSMT'], resolve),
		},{
			path: 'optical-protective-film',
			name: 'OpticalProtectiveFilm',
			meta:{
				title:'Optical protective film',
				bgImg:'image/SiliconMaterial/banner.png',
				pageH1:'Optical protective film',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"Precision Stamping Part"},{"url":"javascript:;","title":"Optical protective film"}],
			},
			component: resolve => require(['@/components/PrecisionStampingPart/OpticalProtectiveFilm'], resolve),
		}]
	},{
		path: '/about-us',
		name: 'AboutUsPage',
		meta: {
			title: 'About us',
			bread:[{"url":"/","title":"Index"},{"url":"","title":" About us"}],
		},
		component: resolve => require(['@/components/AboutUs/listPage'], resolve),
		children: [{
			path: 'contact-us',
			name: '',
			meta:{
				title:'Contact us',
				bgImg:'image/AboutUs/banner.png',
				pageH1:'Contact us',
				bread:[{"url":"/","title":"Index"},{"url":"javascript:;","title":"About us"},{"url":"javascript:;","title":"Contact us"}],
			},
			component: resolve => require(['@/components/AboutUs/ContactUsPage'], resolve),
		}]
	},{
		path: "*",
		name: 'ErrorPage',
		component: resolve => require(['@/components/ErrorPage'], resolve),
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js